import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import WhyUs from "./components/WhyUs";
import MenuPreview from "./components/MenuPreview";
import Testimonials from "./components/Testimonials";
import ContactSection from "./components/ContactSection";
import Footer from "./components/Footer";

const Home = () => {
  return (
    <div className="min-h-screen" dir="rtl">
      <Navbar />
      <Hero />
      <WhyUs />
      <MenuPreview />
      <Testimonials />
      <ContactSection />
      <Footer />
    </div>
  );
};

export default Home;
